<script setup>
import Header from '@/components/Header.vue';
import Icon from '@/components/Icon.vue';
import api from '@/libs/api.js';
import { useConfigStore } from '@/stores/useConfigStore.js';
import { onMounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { formatNumber } from '@/libs/functions';
import PDF from "pdf-vue3";
import ModalShow from "@/components/ModalShow.vue";
const invoices = ref({});
const route = useRoute();
const useConfig = useConfigStore();

const BASE_URL = ref('https://erpaninvest.toeicmax.com')
// Theo dõi sự thay đổi của contract
// watch(
//     () => useConfig.contract,
//     (newContract) => {
//         if (newContract?.id) {
//             console.log(1)
//             getData();
//         }
//     },
//     { immediate: true } // Chạy ngay khi component được mount nếu `contract` đã có giá trị
// );
onMounted(() => {
    if(useConfig.contract){
        getData();
        getUser()
    }
     
})
const getData = async () => {
    if (useConfig.contract?.id) { // Đảm bảo `contract` và `id` tồn tại
        await api.get("/invoice",{
            params:{
                individual : true,
                idContract :  useConfig.contract.id
            }
        }).then((res) => {
            invoices.value = res.data.data; // data trả về từ server
           
        })
    }
};
const userCF = ref({}) 
const getUser = async () => {
     await api.get("/settings/find-by-user",{
            params:{
                id : useConfig.contract?.owner_id
            }
        }).then((res) => {
            userCF.value = res.data.data; // data trả về từ server
           console.log(userCF.value)
        })
   
}
const data = ref({})
const showDetail = ref(false)
const handleDetail = (val) => {
    data.value = val
    showDetail.value = true
     // file()
}
const close = () => {
    showDetail.value = false
}

const file = () => {
    const url = BASE_URL.value + data.value.template.pdf_path;
    console.log(url); // In ra URL để kiểm tra
    fetch(url)
        .then(response => response.blob())
        .then(blob => {
            console.log(blob); // File fetched successfully
        })
        .catch(error => console.error(error));
}
</script>
<template>
    <div class="w-full h-full animation_page overflow-auto">
        <Header text="Hóa đơn" :url="{ name: 'dashboard' }"></Header>
        <div v-if="invoices.data && invoices.data.length > 0 " class="w-full h-auto px-6 py-4 pt-14">
            <div @click="handleDetail(invoice)" v-for="(invoice, index) in invoices.data" :key="index"
                class="w-full h-auto rounded-lg shadow-[0px_0px_8px_0px_#ccc] overflow-hidden bg-white mb-4 mt-2">
                <div class="p-4">
                    <h3 class="font-bold mb-1">
                        {{ invoice.name }}
                    </h3>
                    <div class="flex justify-between items-center">
                        <p class="text-main text-xs font-bold">
                            #{{ invoice.identifier }}
                        </p>
                        <p :class="{
                            'px-2 font-semibold rounded w-max ': true,
                            'bg-red-600 text-white': invoice.status == 0,
                            'bg-green-100 text-green-500': invoice.status == 1
                        }">
                            {{ invoice.status ? 'Đã thanh toán' : 'Chưa thanh toán' }}
                        </p>
                    </div>
                </div>
                 <div class="flex justify-between items-center text-sm font-medium px-4 py-2 border-b border-gray-300" v-for="(item, key) in invoice.items" :key="key">
                    <div>
                        {{item.name}}
                        <div v-if="item.service.type > 2">Số lượng: {{item.quantity}}</div>
                        <div v-if="item.service.type === 1">({{item.start_date }} - {{item.end_date}})</div>
                    </div>
                    <p>{{ formatNumber(item.total) }}</p>
                </div>
                <div class="w-full px-4 pt-6 pb-4 flex justify-between items-center gap-1">
                    <div class="flex justify-start items-center gap-1">
                        <Icon name="qr-code" class="w-5 h-5 fill-main" />
                        <p class="text-main font-bold">Thanh toán</p>
                    </div>
                    <p class="font-bold text-xl">
                        {{ formatNumber(invoice.total) }} VNĐ
                    </p>
                </div>
            </div>
        </div>
        <div v-else class="w-full h-full bg-white pt-14">
            <div class="px-6 py-4 text-center">
                <img src="/assets/images/search-01.jpg" alt="">
                <h3 class="font-bold text-lg">
                    Bạn không có hóa đơn nào!
                </h3>
                <p class="text-xs text-gray-500 py-2">
                    Chờ chút nhé, quản lý tòa nhà sẽ sớm gửi cho bạn các <b>hóa đơn tiền nhà và dịch vụ.</b>
                </p>
                <p class="text-xs text-gray-500 py-2">
                    Hãy theo dõi và thanh toán đúng hạn để dịch vụ không bị gians đoạn
                </p>
            </div>
        </div>
    </div>
     <ModalShow :show="showDetail" title="Thông tin hợp đồng" @call-back="close">
        <div class="w-full h-full bg-white" v-if="data.template.pdf_path">
            <!-- <PDF :src="BASE_URL+data.template.pdf_path" /> -->
           <div class="grid grid-cols-2 gap-2 text-xs px-4 pt-4">
                 <div><img :src="BASE_URL+userCF?.brand_logo_arr[0]?.thumb" alt=""></div>
                <div class="text-right"><span class="font-semibold">HÓA ĐƠN/PAYMENT REQUEST</span></div>
                <div>Căn hộ: <span class="font-semibold">{{data.project.name}}</span></div>
                <div class="text-right">Số/No: <span class="font-semibold">{{data.identifier}}</span></div>
                <div>Phòng: <span class="font-semibold">{{data.room.name}}</span></div>
                <div class="text-right">Ngày: <span class="font-semibold">{{data.issue_date}}</span></div>
                <div>Địa chỉ: <span class="font-semibold">{{data.project.address}}</span></div>
                <div class="text-right">Hạn TT: <span class="font-semibold">{{data.due_date}}</span></div>
                <div>Khách hàng: <span class="font-semibold">{{data.contract.name}}</span></div>
            </div>
            <div class="text-xs mt-4 px-4 border border-gray-200">
               <div class="flex w-full border-y border-gray-200 py-2 text-center font-semibold" >
                   <div class="w-[10%]">STT</div>
                   <div class="w-[30%]">Nội dung</div>
                   <div class="w-[20%]">Đơn giá</div>
                   <div class="w-[10%]">SL</div>
                   <div class="w-[10%]">HS</div>
                   <div class="w-[20%]">TT</div>
               </div>
                <div class="w-full">
                    <div class="flex w-full border-b border-gray-200 text-center" v-for="(item,key) in data.items" :key="key">
                        <div class="w-[10%]  py-2">{{key+1}}</div>
                        <div class="w-[30%]  py-2">{{item.name}}</div>
                        <div class="w-[20%]  py-2">{{ formatNumber(item.price)}}
                            <div class="text-[10px]" v-if="item.service.type == 1">
                                ({{item.start_date}} <br> {{item.end_date}})
                            </div>
                        </div>
                        <div class="w-[10%]  py-2">{{item.quantity.toFixed(2)}}</div>
                        <div class="w-[10%]  py-2">{{item.coefficient.toFixed(2)}}</div>
                        <div class="w-[20%] text-right py-2 font-semibold">{{ formatNumber(item.total) }}</div>
                    </div>
                    <div class="flex w-full border-b border-gray-200 ">
                        <div class="w-[30%]  py-2"></div>
                        <div class="w-[40%] text-right border-r border-gray-200  py-2 pr-2">Tạm tính:</div>
                        <div class="w-[40%] text-right py-2 font-semibold">{{ formatNumber(data.sub_total)}}</div>
                    </div>
                    <div class="flex w-full border-b border-gray-200 ">
                        <div class="w-[30%]  py-2"></div>
                        <div class="w-[40%] text-right border-r border-gray-200 pr-2 py-2">Giảm giá:</div>
                        <div class="w-[40%] text-right py-2 font-semibold">{{ formatNumber(data.promotion)}}</div>
                    </div>
                    <div class="flex w-full border-b border-gray-200 ">
                        <div class="w-[30%]  py-2"></div>
                        <div class="w-[40%] text-right border-r border-gray-200 pr-2 py-2">Thuế:</div>
                        <div class="w-[40%] text-right py-2 font-semibold">{{ formatNumber(data.tax)}}</div>
                    </div>
                    <div class="flex w-full border-b border-gray-200 ">
                        <div class="w-[30%]  py-2"></div>
                        <div class="w-[40%] text-right border-r border-gray-200 pr-2 py-2">Nợ cũ:</div>
                        <div class="w-[40%] text-right py-2 font-semibold">{{ formatNumber(data.total_debt)}}</div>
                    </div>
                    <div class="flex w-full border-b border-gray-200 ">
                        <div class="w-[30%]  py-2"></div>
                        <div class="w-[40%] text-right border-r border-gray-200 pr-2 py-2">Tổng cộng:</div>
                        <div class="w-[40%] text-right py-2 font-semibold">{{ formatNumber(data.total)}}</div>
                    </div>
                    <div class="flex w-full border-b border-gray-200 ">
                        <div class="w-[30%]  py-2"></div>
                        <div class="w-[40%] text-right border-r border-gray-200 pr-2 py-2">Đã thanh toán:</div>
                        <div class="w-[40%] text-right py-2 font-semibold">{{ formatNumber(data.paid)}}</div>
                    </div>
                    <div class="flex w-full border-b border-gray-200 ">
                        <div class="w-[30%]  py-2"></div>
                        <div class="w-[40%] text-right border-r border-gray-200 pr-2 py-2">Phải thanh toán:</div>
                        <div class="w-[40%] text-right py-2 font-semibold">{{ formatNumber(data.total_debt)}}</div>
                    </div>
                </div>
                <div v-if="data.template.link_qr" class="mb-4 flex items-center justify-center w-full h-[300px] my-2">
                    <img :src="data.template.images" alt="" class="w-full h-full object-contain">
                </div>
                <div class="h-40 w-full flex  justify-center">Quét mã thanh toán ở trên! Xin cảm ơn.</div>
            </div>
        </div>
        <div v-else class="flex items-center justify-center mt-5">
            Không tìm thấy hóa đơn
        </div>
    </ModalShow>
</template>